import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setQuestionOptions } from 'Store/AssetInventory/QuestionOption/QuestionOptionAction';
import { GET_QUESTION_OPTIONS } from 'Store/AssetInventory/QuestionOption/QuestionOptionTypes';
import AssetInventoryAPiService from './AssetInventoryAPiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getQuestionOptions(): any {
    try {
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/dropdown/assessment/getquestionoptiontype`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setQuestionOptions(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchGetQuestionOptions() {
    yield takeEvery(GET_QUESTION_OPTIONS, getQuestionOptions)
}

export default function* combinedSaga() {
    yield all([
        watchGetQuestionOptions()
    ])
}